import { FC, ReactElement } from 'react';
import styled from 'styled-components';
import { ErrorBanner } from 'ui/banner';
import { spacing } from 'ui/theme';

const StyledErrorBanner = styled(ErrorBanner)`
  margin: 0 ${spacing.base} ${spacing.threeQuarter} ${spacing.base};
`;

type NodeErrorBannerProps = {
  errorMessage?: string;
};

export const NODE_ERROR_BANNER_TEST_ID = 'node-error-banner';

export const NodeErrorBanner: FC<React.PropsWithChildren<NodeErrorBannerProps>> = ({
  errorMessage = 'something is wrong in its setup',
}): ReactElement => (
  <StyledErrorBanner data-test={NODE_ERROR_BANNER_TEST_ID}>
    Node could not be updated because {errorMessage}. <br />
    Please try again or check our{' '}
    <a href="https://support.iterable.com/hc/en-us" target="_blank" rel="noopener noreferrer">
      Documentation
    </a>{' '}
    for more help.
  </StyledErrorBanner>
);
